<template>
  <div class="webhook-config-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="vertical-align: sub"
          ><i class="el-icon-error text-red"></i> Failed</span
        >
      </div>
      <div>
        <div class="search-area">
          <el-date-picker
            v-model="start_date"
            type="date"
            format="dd-MM-yyyy"
            value-format="yyyy-MM-dd"
            style="width: 160px"
          >
          </el-date-picker>
          <span> - </span>
          <el-date-picker
            v-model="end_date"
            type="date"
            format="dd-MM-yyyy"
            value-format="yyyy-MM-dd"
            style="width: 160px"
          >
          </el-date-picker>
          <el-button
            slot="append"
            type="primary"
            icon="el-icon-search"
            @click="getWebhookFail()"
            >Search</el-button
          >
        </div>

        <div v-if="!company" class="no-company">
          <el-alert
            title="Error alert"
            type="error"
            description="Couldn't load data, please select company"
            show-icon>
          </el-alert>
        </div>


        <el-table v-loading="loading" :data="tableData" border>
          <el-table-column
            sortable
            prop="createdDate"
            label="Date"
            width="160"
            header-align="center"
            align="left"
          >
          </el-table-column>

          <el-table-column
            prop="method"
            label="Method"
            header-align="center"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="
                  scope.row.method && scope.row.method.toLowerCase() == 'post'
                "
                size="mini"
                type="success"
                effect="dark"
                >POST</el-tag
              >
              <el-tag
                v-if="
                  scope.row.method && scope.row.method.toLowerCase() == 'get'
                "
                size="mini"
                effect="dark"
                >GET</el-tag
              >
              <el-tag
                v-if="
                  scope.row.method && scope.row.method.toLowerCase() == 'put'
                "
                type="warning"
                size="mini"
                effect="dark"
                >PUT</el-tag
              >
              <el-tag
                v-if="
                  scope.row.method && scope.row.method.toLowerCase() == 'delete'
                "
                type="danger"
                size="mini"
                effect="dark"
                >DELETE</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="url"
            label="URL"
            min-width="300"
            header-align="center"
            align="left"
          >
          </el-table-column>
          <el-table-column
            prop="request.type"
            label="Type"
            min-width="180"
            header-align="center"
            align="center"
          >
          </el-table-column>

          <el-table-column 
            width="100" 
            label="Request"
            header-align="center"
            align="center"
            >
            <template slot-scope="props">
              <el-popover
                placement="right"
                width="450"
                trigger="click">
                <code class="api-req"><pre v-html="props.row.request"></pre></code>
                
                <el-button icon="el-icon-chat-line-square" size="mini" slot="reference"></el-button>
              </el-popover>
              
            </template>
          </el-table-column>
          <el-table-column
            prop="response"
            label="Response"
            header-align="center"
            align="center"
            width="100"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="uid"
            label="Action"
            header-align="center"
            align="center"
            width="100"
          >
            <template>
              <el-button type="primary" size="mini">Default</el-button>
            </template>
          </el-table-column> -->
        </el-table>

        <el-pagination
          class="pagination-statement"
          @size-change="setPageSize"
          @current-change="setPage"
          :current-page.sync="page"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItem"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { webhookFail } from "@/api/report";
import { currentDateTime, dateFormat } from "@/utils";

export default {
  props: {
    company: String,
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  watch: {
    company(val, old) {
      this.getWebhookFail();
    },
  },
  data() {
    return {
      start_date: currentDateTime("YYYY-MM-DD"),
      end_date: currentDateTime("YYYY-MM-DD"),
      tableData: [],
      loading: false,
      pageSize: 20,
      page: 1,
      totalItem: 0,
    };
  },
  methods: {
    getWebhookFail() {
      if(!this.company){
        return;
      }
      this.loading = true;
      let query = {
        from_date: this.start_date,
        to_date: this.end_date,
        page: this.page,
        items_per_page: this.pageSize,
        order: "desc",
      };
      webhookFail(this.company, query).then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.totalItem = data.data.totalItem;
          this.tableData = data.data.records;
        }
      });
    },
    setPage(val) {
      this.page = val;
      this.getWebhookFail();
    },
    setPageSize(val) {
      this.pageSize = val;
      this.getWebhookFail();
    },
  },
  created() {
   
    this.getWebhookFail();
  },
};
</script>

<style lang="scss">
.webhook-config-container {
  .search-area {
    margin-bottom: 16px;
    button {
      margin-left: 10px;
    }
  }





  .pagination-statement {
    margin-top: 10px;
  }

  .no-company{
    margin: 10px 0;
  }


}
</style>
